import { useRef } from "react";
import { Link } from "@tanstack/react-router";
import { useInViewportOnce } from "@/app/lib/hooks/useInViewportOnce";
import { Image } from "../Image";

type Props = {
  tripId: string;
  src: string;
  title: string;
  onViewed?: () => void;
  onClicked?: () => void;
};

export const TripBanner = ({
  tripId,
  src,
  title,
  onViewed,
  onClicked,
}: Props) => {
  const ref = useRef<HTMLAnchorElement>(null);

  useInViewportOnce(ref, {
    callback: onViewed,
  });

  return (
    <Link ref={ref} to="/trips/$tripId" params={{ tripId }} onClick={onClicked}>
      <Image src={src} alt={title} />
    </Link>
  );
};
